// TagDetailModal.js
import React, { useState, useEffect } from 'react';
import RichTextInput from './RichTextInput';

const TagDetailModal = ({ tag, initialDetail, onSave, onClose }) => {
  const [detail, setDetail] = useState(initialDetail || '');

  // Si cambia el initialDetail, se actualiza el state
  useEffect(() => {
    setDetail(initialDetail || '');
  }, [initialDetail]);

  const handleSave = () => {
    onSave(detail);
    onClose();
  };

  return (
    <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Detalles para {tag.tagName}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <RichTextInput
              initialContent={detail}
              onChange={setDetail}
              placeholder="Escribe los detalles aquí..."
              editorKey={`tag-${tag?.idTag}-detail`}
              style={{ minHeight: '80px' }}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={handleSave}>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagDetailModal;
